import AdminIcon from 'modules/admin/components/AdminIcon';
import useCurrentCampaign from 'modules/campaigns/hook/useCurrentCampaign';
import { DEFAULT_IRRIGATION_VUE } from 'modules/waterBalance/configs/IrrigationRoutePaths';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import HeaderButton from 'shared/components/layout/HeaderButton';
import useServiceSelected from 'shared/hooks/useServiceSelected';
import { ServiceId } from 'shared/models/RouterParam';
import navigationService from 'shared/services/NavigationService';
import { AppState } from 'shared/store';

const VisioCropHeaderButton: React.FC = () => {
  const selected = useServiceSelected(ServiceId.VISIO_CROP);
  const [path, setPath] = useState<string>('');
    const currentCampaign = useCurrentCampaign()

  const {selectedFieldId, selectedCampaign} = useSelector<
    AppState,
    AppState['fields']
  >(({fields}) => fields);

  useEffect(() => {
    let campaignId: number | null = null

    if (selectedCampaign) {
      campaignId = selectedCampaign
    } else {
      campaignId = currentCampaign
    }

      const firstPath = navigationService.getFirstServiceUrl(
        campaignId,
        selectedFieldId,
        ServiceId.VISIO_CROP,
        DEFAULT_IRRIGATION_VUE,
      );
      setPath(firstPath);
  }, [selectedFieldId, selectedCampaign, currentCampaign]);

  return (
    <>
      <HeaderButton
        titleId='visio-crop'
        path={path}
        icon={<AdminIcon selected={selected} />}
        selected={selected}
        serviceId={ServiceId.VISIO_CROP}
      />
    </>
  );
};

export default VisioCropHeaderButton;
